
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface FarmProfile {
  id: string;
  user_id: string;
  username: string | null;
  farm_name: string | null;
  bio: string | null;
  location: string | null;
  usda_zone: string | null;
  hardiness_zone_id: string | null;
  avatar_url: string | null;
  farm_logo_url: string | null;
  farm_website: string | null;
  farming_since: string | null;
  farm_size: string | null;
  farm_images: any;
  farm_goals: string[] | null;
  latitude: number | null;
  longitude: number | null;
  is_discoverable: boolean;
  location_visible: boolean;
  profile_tags: string[] | null;
  is_active: boolean;
}

export const useFarmProfiles = () => {
  const [farms, setFarms] = useState<FarmProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFarms = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("is_active", true)
        .eq("is_discoverable", true)
        .not("farm_name", "is", null)
        .not("location", "is", null);

      if (error) {
        console.error("Error fetching farm profiles:", error);
        setError(error.message);
        return;
      }

      setFarms(data || []);
    } catch (err) {
      console.error("Error fetching farms:", err);
      setError("Failed to fetch farm profiles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFarms();
  }, []);

  return {
    farms,
    loading,
    error,
    refetch: fetchFarms,
  };
};
